<script>
  import CheckboxButton from '@/_legacy/components/Form/CheckboxButton.vue';

  export default {
    name: 'ConductInspectionItemQuestionCheckbox',
    components: { CheckboxButton },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      valueChanged(value) {
        this.$emit('change', {
          uuid: this.item.uuid,
          response: value,
          responded: value === true,
        });
      },
    },
  };
</script>

<template>
  <CheckboxButton :checked="item.response" @input="valueChanged" />
</template>
